import { call, put, takeLatest } from "redux-saga/effects";
import {
  addBlockFailure,
  addBlockSuccess,
  deleteBlockFailure,
  deleteBlockSuccess,
  fetchAllBlocksFailure,
  fetchAllBlocksSuccess,
  fetchBlockFailure,
  fetchBlocksFailure,
  fetchBlocksSuccess,
  fetchBlockSuccess,
  updateBlockFailure,
  updateBlockSuccess,
} from "./blockAction";
import {
  addBlockEffect,
  deleteBlockEffect,
  editBlockEffect,
  listAllBlockEffect,
  listBlockEffect,
  ViewBlockEffect,
} from "./blockEffect";
import {
  ADD_BLOCK_REQUEST,
  DELETE_BLOCK_REQUEST,
  FETCH_BLOCK_REQUEST,
  FETCH_LIST_ALL_BLOCK_REQUEST,
  FETCH_LIST_BLOCK_REQUEST,
  UPDATE_BLOCK_REQUEST,
} from "./blockType";

function* fetchBlocksSaga(action) {
  try {
    const Blocks = yield call(listBlockEffect, action.payload);
    yield put(fetchBlocksSuccess(Blocks));
  } catch (error) {
    yield put(fetchBlocksFailure(error.message));
  }
}

function* fetchAllBlocksSaga(action) {
  try {
    const Blocks = yield call(listAllBlockEffect, action.payload);
    yield put(fetchAllBlocksSuccess(Blocks));
  } catch (error) {
    yield put(fetchAllBlocksFailure(error.message));
  }
}
function* fetchBlockSaga(action) {
  try {
    const Block = yield call(ViewBlockEffect, action.payload.BlockId);
    yield put(fetchBlockSuccess(Block));
  } catch (error) {
    yield put(fetchBlockFailure(error.message));
  }
}

function* addBlockSaga(action) {
  try {
    const newBlock = yield call(addBlockEffect, action?.payload?.blockData);
    yield put(addBlockSuccess(newBlock));
  } catch (error) {
    yield put(addBlockFailure(error.message));
  }
}

function* updateBlockSaga(action) {
  try {
    const updatedBlock = yield call(
      editBlockEffect,
      action.payload?.blockId,
      action.payload.blockId?.id
    );
    yield put(updateBlockSuccess(updatedBlock));
  } catch (error) {
    yield put(updateBlockFailure(error.message));
  }
}

function* deleteBlockSaga(action) {
  try {
    yield call(deleteBlockEffect, action.payload.blockId);
    yield put(deleteBlockSuccess(action.payload.BlockId));
  } catch (error) {
    yield put(deleteBlockFailure(error.message));
  }
}

export function* BlockSagas() {
  yield takeLatest(FETCH_LIST_BLOCK_REQUEST, fetchBlocksSaga);
  yield takeLatest(FETCH_LIST_ALL_BLOCK_REQUEST, fetchAllBlocksSaga);
  yield takeLatest(FETCH_BLOCK_REQUEST, fetchBlockSaga);
  yield takeLatest(ADD_BLOCK_REQUEST, addBlockSaga);
  yield takeLatest(UPDATE_BLOCK_REQUEST, updateBlockSaga);
  yield takeLatest(DELETE_BLOCK_REQUEST, deleteBlockSaga);
}
